import { render, staticRenderFns } from "./MallList.vue?vue&type=template&id=149bde83&"
import script from "./MallList.vue?vue&type=script&lang=ts&"
export * from "./MallList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports